import * as bootstrap from 'bootstrap';


// Add your custom JS here.
// jQuery(function() { 
//   jQuery('body').on('added_to_cart', function() {
//     console.log('Item was added to cart'); 	
//   }); 
// });

// function updateCartState() {
//   jQuery('.widget_shopping_cart_content').find('.woocommerce-mini-cart-item').length
// }


// jQuery(window).on('load', function() {
//     $('.modal').modal('show');
// });


// const myModalEl = document.getElementById('myModal')




document.addEventListener('DOMContentLoaded', function() {
  const href = window.location.href;

  if (href == "https://idzumi.ch/" || href == 'http://localhost:3000/') {
    var myModal = new bootstrap.Modal(document.getElementById('myModal'));
    myModal.show();
  }  
});
